import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { GradingExercise } from "src/app/shared/interfaces/grading-exercise";
import { Guid } from "src/app/shared/types/guid";

export const prefix = "[Get Grading Exercises]";

const getGradingExercisesActions = {
  request: `${prefix} Load`,
  requestActiveSuccess: `${prefix} Load success`,
  requestFail: `${prefix} Load fail`,
};

export const getGradingExercisesLoad = createAction(
  getGradingExercisesActions.request,
  props<{ CourseId: Guid }>(),
);

export const getGradingExercisesLoadSuccess = createAction(
  getGradingExercisesActions.requestActiveSuccess,
  props<{ exercises: GradingExercise[] }>(),
);

export const getGradingExercisesLoadFailure = createAction(
  getGradingExercisesActions.requestFail,
  props<{ error: HttpErrorResponse }>(),
);
